/**
 * Add to Mimir (ACP-D48, docs/gfx-mimir-publish/plan.md): a published template version made into a new Mimir graphics
 * item on the stage's Mimir (research4 on dev). The cloud does it server-side — the Mimir API key never reaches a
 * browser — with `@ssoreide/gfx-mimir`'s upload. Routes: `graphicsMimirRoutes.ts`.
 */
import { z } from 'zod';
import { sha256HexWireSchema } from './primitives.js';

export const addGraphicsTemplateVersionToMimirRequestWireSchema = z
  .object({
    /**
     * A 320×240 PNG poster for the item, uploaded first as a content object (`POST /graphics/content/uploads`), or
     * null for none. `validation-failed` naming `thumbnailSha256` when the tenant has no such object.
     */
    thumbnailSha256: sha256HexWireSchema.nullable(),
  })
  .strict();
export type AddGraphicsTemplateVersionToMimirRequestWire = z.infer<typeof addGraphicsTemplateVersionToMimirRequestWireSchema>;

export const addGraphicsTemplateVersionToMimirResponseWireSchema = z
  .object({
    /** The new Mimir graphics item's id (also appended to the version's `mimirItems`). */
    itemId: z.string(),
    /** Its title in Mimir: the version's name and number (`Lower third (v3)`). */
    title: z.string(),
  })
  .strict();
export type AddGraphicsTemplateVersionToMimirResponseWire = z.infer<typeof addGraphicsTemplateVersionToMimirResponseWireSchema>;

export const graphicsMimirStatusResponseWireSchema = z
  .object({
    /** Whether Add to Mimir can work on this stack: its settings (base URL, module URL, secret), the secret's value, and a hosted module whose `gfx-mimir.json` can be read; the designer hides Add to Mimir without them. */
    configured: z.boolean(),
    /** Whether the caller holds `graphics.mimir` tenant-wide. */
    permitted: z.boolean(),
  })
  .strict();
export type GraphicsMimirStatusResponseWire = z.infer<typeof graphicsMimirStatusResponseWireSchema>;
